import { render } from "./thankyourejectdiy.vue?vue&type=template&id=238ee73c&scoped=true"
import script from "./thankyourejectdiy.vue?vue&type=script&lang=js"
export * from "./thankyourejectdiy.vue?vue&type=script&lang=js"

import "./thankyourejectdiy.vue?vue&type=style&index=0&id=238ee73c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238ee73c"]])

export default __exports__